import { useEffect } from 'react'

import { useStoreContext } from 'hooks/StoreContext'

import Api from 'services/api'

const useVerificationReports = (deviceId) => {
  const {
    verificationReports,
    setVerificationReports,
    areVerificationReportsLoaded,
    setAreVerificationReportsLoaded
  } = useStoreContext()

  useEffect(() => {
    setAreVerificationReportsLoaded(false)
    setVerificationReports(null)

    Api.VerificationReports.list(deviceId)
      .then((response) => {
        setVerificationReports(response)
      })
      .catch(() => {
        setVerificationReports(null)
      })
      .finally(() => {
        setAreVerificationReportsLoaded(true)
      })
  }, [deviceId, setAreVerificationReportsLoaded, setVerificationReports])

  return { verificationReports, areVerificationReportsLoaded }
}

export default useVerificationReports
